import { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { get } from './helpers';

export const useApiLoading = (key, type, defaultState = true) => {
  const loading = useSelector(state => get(state, `reqq.LOADING/${type}/${key}`), shallowEqual);
  const [init, setInit] = useState(defaultState);
  useEffect(() => {
    setInit(false);
  }, []);
  return (loading || init);
};
const DEFAULT_VALUE = {};
export const useApiGet = (key, default_value = DEFAULT_VALUE) => {
  const [defaultValue] = useState(default_value);
  const selected = useSelector((state) => {
    const v = get(state, `reqq.${key}`);
    return (v === null || v === undefined) ? defaultValue : v
  }, shallowEqual);
  return selected;
};
